import React from 'react';
import './App.scss';
import StyledTheme from './StyledTheme';
import { Navbar } from './components';
import { Experience, Footer, Header, Skills, Work } from './container';
const App = () => {
	return (
		<div className='app'>
			<StyledTheme>
				<Navbar />
				<Header />
				<Skills />
				<Experience />
				<Work />
				<Footer />
			</StyledTheme>
		</div>
	);
};

export default App;
